import { Api } from "../config/request";

// API function to get my cart
const getUserCartTokens = async (data) => {
    let response = await Api.PostRequest("/getUserCartTokens", data);
    return response.data;
};

// API function to save to cart
const addToCart = async (data) => {
    let response = await Api.PostRequest("/addToCart", data);
    return response.data;
};

// API function to remove from cart
const removecartItem = async (data) => {
    let response = await Api.PostRequest("/removecartItem", data);
    return response.data;
};

const clearWholeCart = async (data) => {
    let response = await Api.PostRequest("/clearWholeCart", data);
    return response.data;
};

// API function to remove token from cart
const removeTokenFromCart = async (data) => {
    let response = await Api.PostRequest("/removeTokenFromCart", data);
    return response.data;
};

// API function to checkout payment
const checkoutPayment = async (data) => {
    let response = await Api.PostRequest("/checkout", data);
    return response.data;
};

//API function for payment intent
const paymentIntent = async (data) => {
    let response = await Api.PostRequest("/create-payment-intent", data);
    return response.data;
}

//API function for payment intent
const paymentButtonIntent = async (data) => {
    let response = await Api.PostRequest("/createPaymentIntent", data);
    return response.data;
}

//API function for payment intent
const capturePaymentButtonIntent = async (data) => {
    let response = await Api.PostRequest("/capture/paypal", data);
    return response.data;
}

//API function for payment status
const paymentStatus = async (data) => {
    let response = await Api.PostRequest("/updateOrderStatus", data);
    return response.data;
}

//API function to start payment process
const startProcessingPayment = async (data) => {
    let response = await Api.PostRequest("/updateOrderPaymentStatusInProgress", data);
    return response.data;
}

// FOR DEMO
const checkoutPaymentCoins = async (data) => {
    let response = await Api.PostRequest("/checkoutWithoutIntent", data);
    return response.data;
};

const cartApi = {
    getUserCartTokens,
    addToCart,
    checkoutPayment,
    removecartItem,
    clearWholeCart,
    removeTokenFromCart,
    paymentIntent,
    paymentStatus,
    paymentButtonIntent,
    capturePaymentButtonIntent,
    startProcessingPayment,  
    checkoutPaymentCoins, 
};

export default cartApi;
